export default __webpack_public_path__ + "static/logo-c55e3f7ce4afedefddb837af857e9e2d.png";